import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Form } from 'react-bootstrap';
import actions from '../../redux/actions';
import Heading from '../Heading';
import NavButtons from '../NavButtons';

class CreateAgreementSoundRecordingSplitType extends Component {
  handleWorkType(e, type) {
    e.preventDefault();
    const { params } = this.props;

    this.props.assignAttribute('soundRecordingType', type);
    this.props.router.push(
      `/create/agreement-ownership-percentage/${params.page}`
    );
  }

  handlePrev() {
    const { params } = this.props;

    if (params.page === 'split') {
      this.props.router.push('/create/agreement-ownership-split');
    } else {
      this.props.router.push('/create/agreement-ownership-premium-split');
    }
  }

  render() {
    return (
      <div className="select-split-type">
        <Heading text="What do you want to split?" />

        <div className="content">
          <Form>
            <Row>
              <Col md={6} sm={12} className="type-view">
                <div
                  className="type-image"
                  onClick={(e) => this.handleWorkType(e, 'revenue')}
                >
                  <span>Reveneu From Sound Recordings</span>
                  {/* <span>(one song, one image, one video, etc.)</span> */}
                </div>
              </Col>
              <Col md={6} sm={12} className="type-view">
                <div
                  className="type-image"
                  onClick={(e) => this.handleWorkType(e, 'ownership')}
                >
                  <span>Ownership of Sound Recordings</span>
                  {/* <span>(a group of works organized into an official collection, like an album of music.)</span> */}
                </div>
              </Col>
            </Row>
          </Form>
        </div>

        <div className="step-nav">
          <NavButtons direction="back" prev={() => this.handlePrev()} />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignAttribute(field, attribute));
  },
});

export default connect(
  null,
  mapDispatchToProps
)(CreateAgreementSoundRecordingSplitType);



// WEBPACK FOOTER //
// src/components/Agreements/CreateAgreementSoundRecordingSplitType.jsx